<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4>Pilih Alamat</h4>
        <div class="loadingAddress" v-if="loading"></div>
        <div class="addresses" v-else>
          <div class="addressItem" v-for="(item, i) in results" :key="`address${i}`"
            :class="{mainAddress: item.mainAddress === 1}">
            <div class="addressLabel">{{item.label}}
              <span class="mainAddress" v-if="i === 1">Alamat Utama</span></div>
            <h4>{{item.recipient}} <span>({{item.phone}})</span></h4>
            <div class="addrNotes" v-if="item.notes && item.notes !== ''">
              {{item.notes}}
            </div>
            <div class="theAddress">
              <p>{{item.userAddress}}<span v-if="item.rtrw">, RT/RW {{item.rtrw}}</span><span
                v-if="item.subDistrict">, Desa {{item.subDistrict}}</span><span
                v-if="item.district">, Kec. {{item.district}}</span><span
                v-if="item.cityName">, Kota {{item.cityName}}</span><span
                v-if="item.provinceName">, Provinsi {{item.provinceName}}</span><span
                v-if="item.postalCode"> - {{item.postalCode}}</span></p>
            </div>
            <button class="btn primary" v-on:click="close(true, item)">
              Pilih <span>Alamat</span></button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      next: null,
      loading: true,
      results: [],
    };
  },
  methods: {
    open(d, n) {
      this.loading = true;
      this.next = n;
      this.show = true;
      this.$http.get(this.$config.uri('user/address')).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : null;
      });
    },
    close(b, v) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.5);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      max-width: none;
      width: 640px;
      @media (max-width: 680px) {
        width: auto;
        left: 10px; right: 10px;
        padding: 30px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      .loadingAddress{
        height: 200px;
        background-size: 46px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/loading.svg);
      }
      .addresses{
        padding: 10px 40px 0;
        margin: 0 -40px;
        max-height: 480px;
        overflow-y: auto;
        border-top: #eee 1px solid;
        border-bottom: #eee 1px solid;
        .addressItem{
          border-radius: 5px;
          border: #eee 1px solid;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          padding: 16px 20px;
          margin-bottom: 20px;
          position: relative;
          padding-right: 140px;
          @media (max-width: 680px) {
            padding-right: 84px;
          }
          &.mainAddress{
            background-color: #fffef7;
            border-color: #f6cf06;;
          }
          .addrNotes{
            padding: 4px 10px;
            background-image: linear-gradient(to right, #fae502, transparent);
            display: inline-block;
            border-radius: 3px;
            margin: 4px 0 6px;
            padding-left: 30px;
            position: relative;
            &:before{
              content: "";
              position: absolute;
              left: 6px; top: 2px; bottom: 2px; width: 20px;
              background-image: url(../assets/notes.png);
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          .btn.primary{
            position: absolute;
            right: 20px; top: 20px;
            padding: 8px 16px;
            font-size: 15px;
            font-weight: 500;
            border-radius: 3px;
            @media (max-width: 680px) {
              right: 14px;
            }
            span{
              @media (max-width: 680px) {
                display: none;
              }
            }
          }
          .addressLabel{
            font-size: 12px;
            font-weight: 800;
            color: #858585;
            margin: 0 0 4px;
            text-transform: uppercase;
          }
          h4{
            margin: 0 0 4px;
            font-size: 16px;
            font-weight: 600;
          }
          .theAddress{
            font-size: 14px;
            p{
              margin: 0;
              line-height: 1.4;
            }
          }
          .addressAction{
            display: flex;
            padding: 10px 20px 0;
            border-top: #eee 1px solid;
            margin: 16px -20px 0;
            .btn{
              padding: 0;
              margin-right: 30px;
              font-size: 14px;
              box-shadow: none;
            }
          }
        }
      }
    }
  }
</style>
